import { CheckCircle, AlertTriangle } from 'lucide-react';

interface RegistryStatusCardProps {
    status: {
        isRegistered: boolean;
        pid?: string;
        registrationNumber?: string;
        unitCount?: number;
        message: string;
    };
}

export const RegistryStatusCard: React.FC<RegistryStatusCardProps> = ({ status }) => {
    if (status.isRegistered) {
        return (
            <div className="rounded-lg border border-green-200 bg-green-50 p-6">
                <div className="flex items-start gap-3">
                    <CheckCircle className="h-6 w-6 text-green-600 flex-shrink-0" />
                    <div className="flex-1">
                        <h3 className="font-semibold text-green-900 mb-2">
                            Registry Found: Active
                        </h3>
                        <dl className="space-y-1 text-sm text-green-800">
                            {status.pid && (
                                <div className="flex gap-2">
                                    <dt className="font-medium">PID:</dt>
                                    <dd>{status.pid}</dd>
                                </div>
                            )}
                            {status.registrationNumber && (
                                <div className="flex gap-2">
                                    <dt className="font-medium">Registration:</dt>
                                    <dd>{status.registrationNumber}</dd>
                                </div>
                            )}
                            {status.unitCount && (
                                <div className="flex gap-2">
                                    <dt className="font-medium">Units:</dt>
                                    <dd>{status.unitCount}</dd>
                                </div>
                            )}
                        </dl>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="rounded-lg border border-red-200 bg-red-50 p-6">
            <div className="flex items-start gap-3">
                <AlertTriangle className="h-6 w-6 text-red-600 flex-shrink-0" />
                <div className="flex-1">
                    <h3 className="font-semibold text-red-900 mb-2">
                        Warning: Property Not Found in HRM Registry
                    </h3>
                    <p className="text-sm text-red-800 mb-3">
                        {status.message || 'You are at risk of fines up to $10,000. Register your property at Halifax.ca'}
                    </p>
                    <a
                        href="https://www.halifax.ca/home-property/property-taxes/residential-rental-property-registration"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center text-sm font-medium text-red-900 hover:underline"
                    >
                        Register Now at Halifax.ca →
                    </a>
                </div>
            </div>
        </div>
    );
};
